module.exports = __webpack_public_path__ + "img/lens-174-minus-01.f7a4e8f9.png";